export default "__VITE_ASSET__VjU1E_K6__";